/**
 * Utility to clear the IndexedDB database
 * This is needed when the database schema changes
 */
export async function clearDatabase(): Promise<void> {
  const DB_NAME = 'phoneverse';
  
  try {
    // Close any open connections first
    const { closeDb } = await import('../db/connection');
    await closeDb();
    
    // Delete the database
    await new Promise<void>((resolve, reject) => {
      const deleteReq = indexedDB.deleteDatabase(DB_NAME);
      
      deleteReq.onsuccess = () => {
        console.log(`Database '${DB_NAME}' deleted successfully`);
        resolve();
      };
      
      deleteReq.onerror = () => {
        console.error(`Failed to delete database '${DB_NAME}'`);
        reject(deleteReq.error);
      };
      
      deleteReq.onblocked = () => {
        console.warn(`Delete blocked for database '${DB_NAME}'. Close all tabs using this database.`);
      };
    });
    
    // Also clear localStorage to ensure clean state
    const keysToKeep = ['devMode']; // Keep dev mode setting
    const allKeys = Object.keys(localStorage);
    
    allKeys.forEach(key => {
      if (!keysToKeep.includes(key)) {
        localStorage.removeItem(key);
      }
    });
    
    console.log('Database and storage cleared successfully');
  } catch (error) {
    console.error('Error clearing database:', error);
    throw error;
  }
}

// Export a function to check if database needs clearing
export function isDatabaseVersionMismatch(): boolean {
  // This will be true if we get version mismatch errors
  // For now, we'll just return true to force a clear on next run
  return true;
}